// All landing-page copy (Hebrew). Ported from fbzipper-new-landing/landing/src/strings.js.
export const T = {
  lang: 'he',
  dir: 'rtl',
  title: 'FBZipper: פרסום אוטומטי בפייסבוק שמביא לכם לידים',
  arrow: '←',
  nav: { reviews: 'המלצות', how: 'איך זה עובד', tutorial: 'מדריך וידאו', pricing: 'מחיר', faq: 'שאלות נפוצות', contact: 'צור קשר', cta: 'מתחילים עכשיו', login: 'התחברות', app: 'כניסה למערכת' },
  hero: {
    eyebrow: 'שיווק בפייסבוק על טייס אוטומטי',
    badge: 'רץ בענן מאובטח, על הפרופיל שלכם',
    title: ['כל הקבוצות בפייסבוק. כל יום. ', 'יותר לידים', '.'],
    lede: 'מעלים את הפוסטים לדשבורד של FBZipper פעם אחת. מאותו רגע FBZipper מפעיל את הפרופיל שלכם מהענן המאובטח שלנו: מצטרף לקבוצות חדשות, מפרסם בכל הקבוצות הרלוונטיות כל היום, כל יום, מתייג ועונה לכל מי שמגיב, עונה במסנג׳ר ומנהל את המודעות במרקטפלייס. תמיד בתוך המגבלות של הפרופיל, כדי שהפרופיל לא יוגבל.',
    cta: 'מתחילים לקבל לידים',
    demo: 'צפו איך זה עובד',
    proof: ['אלפי לקוחות מרוצים', 'כל הקבוצות בישראל, לפי תחום ואזור', 'שומר על מגבלות הפרופיל', 'כל תגובה הופכת לליד'],
  },
  demo: {
    label: 'דוגמה: FBZipper מריץ יום של קמפיינים, תגובות, מסנג׳ר ומרקטפלייס',
    play: 'צפו איך זה עובד',
    playSub: 'עם סאונד 🔊 · דקה וחצי',
    replay: 'לצפייה חוזרת',
    pause: 'השהיה',
    resume: 'המשך',
    mute: 'השתקה',
    unmute: 'הפעלת סאונד',
    bar: { live: 'טייס אוטומטי פועל', posts: 'פוסטים', joined: 'קבוצות נוספו', leads: 'לידים' },
    upload: {
      url: 'console.fbzipper.com',
      connected: 'הפרופיל חובר תוך דקות',
      title: 'הפוסטים שלכם',
      button: '+ העלאת פוסטים',
      posts: [
        { e: '🏠', name: '3 חדרים משופצת בדיזנגוף', meta: '4 תמונות · ₪7,200' },
        { e: '👟', name: 'מבצע קיץ על נעלי ספורט', meta: '6 תמונות · החל מ-₪189' },
        { e: '💼', name: 'דרושים: נציגי מכירות', meta: 'טקסט + קישור' },
      ],
      uploading: 'מעלה…',
      ready: 'מוכן',
      chips: ['🗓 כל יום, כל היום', '🎯 142 קבוצות', '☁️ ענן מאובטח'],
      autopilot: 'טייס אוטומטי',
    },
    db: {
      title: 'מאגר הקבוצות של ישראל',
      count: 'מצרפים אתכם לקבוצות רלוונטיות · 4,812 התאמות',
      filters: ['נדל״ן', 'תל אביב', 'מרכז'],
      join: 'הצטרפות',
      joined: 'צורפתם',
      posted: 'פורסם',
      members: 'חברים',
      human: 'קצב של בן אדם: הפסקות אקראיות ותזמון טבעי',
      posting: 'מפרסמים בקבוצות פייסבוק',
      groupN: (n, total) => `קבוצה ${n} מתוך ${total}`,
      publishing: 'מפרסם…',
      public: 'קבוצה ציבורית',
      limit: 'המגבלה היומית של הפרופיל',
      limitOk: 'בטוח',
      cloud: 'ענן מאובטח · הפרופיל שלכם',
      search: 'חיפוש בפייסבוק',
      feedTitle: 'הפוסטים שלכם, בכל פיד',
    },
    groups: [
      ['דירות להשכרה בתל אביב', '128K'],
      ['השכרות רמת גן וגבעתיים', '64K'],
      ['יד שנייה תל אביב', '211K'],
      ['נדל״ן אזור המרכז', '47K'],
      ['קהילת חולון ובת ים', '93K'],
      ['עוברים לתל אביב?', '38K'],
    ],
    from: { profile: 'פרופיל', page: 'דף עסקי' },
    pageName: 'דנה נדל״ן',
    actions: ['אהבתי', 'תגובה', 'שיתוף'],
    post: {
      author: 'דנה לוי',
      group: 'דירות להשכרה בתל אביב',
      when: 'עכשיו',
      text: '🏠 דירת 3 חדרים משופצת בדיזנגוף, עם מרפסת, ₪7,200. פנויה מיד!',
      comments: [
        ['מאיה כהן', 'המחיר כולל ארנונה?'],
        ['יוסי מזרחי', 'אשמח לפרטים 🙏'],
        ['נועה פרץ', 'עדיין רלוונטי?'],
      ],
      reply: 'היי! שולחים לך עכשיו את כל הפרטים. דנה: 050-1234567 📞',
      autoTag: 'מענה אוטומטי',
      actions: ['אהבתי', 'השב'],
      ago: ['1 דק׳', '1 דק׳', 'עכשיו'],
    },
    leads: { title: 'לידים חדשים', from: 'הגיב/ה ב', newLead: 'ליד חדש' },
    messenger: {
      title: 'מסנג׳ר',
      who: 'אבי בן דוד',
      active: 'פעיל/ה עכשיו',
      msg: 'היי, הדירה עדיין פנויה?',
      reply: 'היי אבי! כן 🙂 זה הטלפון הישיר של דנה: 050-1234567',
      auto: 'נענה אוטומטית',
    },
    market: {
      title: 'מרקטפלייס',
      sub: 'כל המודעות שלכם, במקום אחד',
      items: [
        { e: '🛋️', t: 'ספה תלת-מושבית אפורה', p: '₪1,200', bg: '#E4D4FF' },
        { e: '👟', t: 'נעלי ריצה', p: '₪189', bg: '#CDE7FF' },
        { e: '🚲', t: 'אופני עיר', p: '₪650', bg: '#B9E4C9' },
        { e: '📱', t: 'אייפון 14 כמו חדש', p: '₪2,100', bg: '#FFD6A5' },
      ],
      live: 'פעילה',
      buyer: 'קונה שאל ״אפשר לאסוף היום?״ · נענה',
    },
    steps: [
      'מתחברים תוך דקות ומעלים פוסטים',
      'מצרפים אתכם לקבוצות רלוונטיות',
      'מפרסמים כל היום, במגבלות הפרופיל',
      'כל מי שמגיב מקבל תיוג ותשובה',
      'עונים אוטומטית במסנג׳ר',
      'מנהלים את המודעות במרקטפלייס',
      'מאות המלצות בוידאו',
      'ניסיון 7 ימים חינם, בלי תשלום',
    ],
    reviews: { title: 'מה הלקוחות שלנו אומרים', big1: 'מאות', sub1: 'המלצות בוידאו', big2: 'אלפי', sub2: 'לקוחות מרוצים', cta: 'אל תישארו מאחור' },
    outro: {
      price: '₪290',
      per: 'לחודש',
      month: 'רץ בענן מאובטח, על הפרופיל שלכם',
      points: ['פרסום בכל הקבוצות הרלוונטיות, כל היום, כל יום', 'מצרפים אתכם לקבוצות רלוונטיות, במגבלות הפרופיל', 'כל תגובה והודעה הופכות לליד'],
      nudge: 'אפס סיכון, פוטנציאל ענק. אל תחכו.',
      trialBig: '7 ימים',
      trialSub: 'ניסיון חינם',
      after: 'בלי תשלום · אחר כך ₪290 לחודש',
      cta: 'מתחילים ניסיון חינם',
      wa: 'יש שאלה? דברו איתנו בוואטסאפ',
    },
  },

  math: {
    eyebrow: 'החשבון',
    title: 'לפרסם ב-300 קבוצות ידנית? זו משרה מלאה.',
    handLabel: 'עושים את זה לבד',
    handBig: 'כ-5 שעות ביום',
    hand: 'מחפשים קבוצות, מבקשים להצטרף, מחכים, מדביקים את הפוסט בכל אחת, בודקים תגובות, עונים אחד-אחד, עונים במסנג׳ר. כל יום. פספסתם תגובה? הפסדתם ליד.',
    withLabel: 'עם FBZipper',
    withBig: '0 דקות',
    with: 'מעלים את הפוסטים לדשבורד פעם אחת. מאותו רגע הפוסטים יוצאים כל היום, כל יום, מצטרפים לקבוצות חדשות, וכל תגובה והודעה מקבלות את הפרטים שלכם.',
  },
  features: {
    eyebrow: 'מה כלול',
    title: 'כל מה שהשיווק שלכם בפייסבוק צריך, עושים בשבילכם.',
    items: [
      ['🤖', 'פרסום אוטומטי בכל הקבוצות', 'כל הפוסטים שלכם יתפרסמו אוטומטית בכל קבוצות הפייסבוק הרלוונטיות, מ-7 בבוקר ועד 11 בלילה.'],
      ['🔗', 'הצטרפות אוטומטית לקבוצות', 'אנחנו נצרף את הפרופיל שלכם לקבוצות חדשות באופן אוטומטי, כך תגיעו לקהלים חדשים שלא הגעתם אליהם עד היום.'],
      ['🏢', 'פרסום גם מהדפים העסקיים', 'מפרסמים מהפרופיל וגם מהדפים העסקיים שלכם, כדי שיותר פוסטים ייצאו כל יום.'],
      ['💬', 'ניהול תגובות ותיוג מתעניינים', 'כל מי שיגיב על הפוסטים ויכתוב ״אשמח לפרטים״, ״מחיר?״ או כל שאלה, נתייג את הפרופיל שלו ונגיב לו עם הפרטים שלכם. כל תגובה הופכת לליד.'],
      ['📩', 'מענה אוטומטי במסנג׳ר', 'כל הודעה שתגיע למסנג׳ר שלכם תקבל מענה עם הפרטים שלכם ליצירת קשר.'],
      ['🛍️', 'ניהול מרקטפלייס', 'ניהול כל המודעות שלכם במרקטפלייס של פייסבוק ממקום אחד: סנכרון, עריכה, מענה לקונים ויצירת מודעות חדשות.'],
      ['🗂', 'מאגר הקבוצות הגדול בישראל', 'ברשותנו מאגר של כל הקבוצות בישראל, מפולחות לפי קטגוריות, תחומים, אזורים ועוד.'],
      ['☁️', 'ענן מאובטח, הפרופיל שלכם, המגבלות שלכם', 'FBZipper רץ בענן המאובטח שלנו עם הפרופיל שלכם, בקצב של בן אדם, ותמיד בתוך המגבלות היומיות של הפרופיל, כדי שהפרופיל לא יוגבל.'],
      ['📤', 'דשבורד אחד לכל הפוסטים', 'מעלים את הפוסטים, התמונות והמחירים לדשבורד של FBZipper. זה הדבר היחיד שאתם עושים, כל השאר רץ לבד.'],
      ['☎️', 'שירות לקוחות כל יום', 'שירות הלקוחות זמין מדי יום בין 9:00 ל-17:00 לכל שאלה.'],
    ],
  },
  reviews: {
    eyebrow: 'המלצות',
    title: ['מאות ', 'המלצות בוידאו', '.'],
    lede: 'הצטרפו לאלפי לקוחות מרוצים שכבר מקבלים לידים מפייסבוק כל יום. אל תישארו מאחור.',
    stars: 'אלפי לקוחות מרוצים',
    play: 'ניגון המלצה',
    more: 'עוד סרטונים',
    close: 'סגירה',
  },
  value: {
    eyebrow: 'מה אתם מקבלים',
    title: ['משווק פייסבוק במשרה מלאה, ב', 'פחות מ-₪10 ליום', '.'],
    lede: 'לעשות את כל זה לבד לוקח שעות כל יום. להעסיק מישהו שיעשה את זה עולה אלפי שקלים בחודש. FBZipper עושה את זה כל היום, כל יום, בשבריר מהמחיר.',
    compare: [['לעשות את זה לבד', 'כ-5 שעות ביום'], ['להעסיק מנהל/ת סושיאל', 'אלפי ₪ בחודש']],
    us: 'FBZipper',
    usPrice: '₪290 לחודש',
    usSub: '7 ימי ניסיון חינם, בלי כרטיס אשראי',
    items: [
      ['📣', 'הפוסטים שלכם בכל מקום, כל יום', 'בכל הקבוצות הרלוונטיות, כל היום, כל יום, במקום בכמה קבוצות שיש לכם זמן אליהן.'],
      ['🌱', 'קהלים חדשים כל שבוע', 'FBZipper ממשיך לצרף אתכם לקבוצות חדשות, כך שהחשיפה שלכם רק גדלה.'],
      ['🎯', 'אף ליד לא הולך לאיבוד', 'כל תגובה וכל הודעה במסנג׳ר מקבלות את הפרטים שלכם, גם בשעות הערב.'],
      ['⏱️', 'הזמן שלכם חוזר אליכם', 'השעות של העתק-הדבק, הצטרפות לקבוצות ומענה לתגובות חוזרות לעסק שלכם.'],
    ],
  },
  how: {
    eyebrow: 'איך זה עובד',
    title: 'שלושה צעדים, ומשם זה רץ לבד.',
    steps: [
      ['מתחברים ומעלים', 'מחברים את הפרופיל בפייסבוק תוך דקות, ומעלים לדשבורד של FBZipper את הפוסטים, התמונות, המחירים והפרטים. זה הדבר היחיד שאתם עושים.'],
      ['בוחרים קבוצות', 'בוחרים קבוצות מהמאגר של כל הקבוצות בישראל, לפי תחום ואזור. FBZipper מצטרף בשבילכם לחדשות.'],
      ['לידים נכנסים כל יום', 'הפוסטים יוצאים כל היום, כל יום, בתוך המגבלות של הפרופיל. כל תגובה, הודעה במסנג׳ר וקונה במרקטפלייס מקבלים את הפרטים שלכם.'],
    ],
  },
  tutorial: {
    eyebrow: 'מדריך וידאו',
    title: 'רוצים לראות את המערכת מבפנים?',
    lede: 'מדריך קצר עם קריינות שמראה בדיוק מה עושים בכניסה הראשונה: מההתחברות ועד שהפוסטים מתחילים לצאת לבד.',
    points: ['יוצרים קמפיין ומוסיפים פוסט', 'בוחרים קבוצות מהמאגר', 'מחברים את הפרופיל בפייסבוק', 'המערכת מפרסמת אוטומטית'],
    cta: 'צפו במדריך',
    cardTitle: 'איך עובדים עם FBZipper',
    cardSub: 'מדריך מלא עם קריינות · בנייד: סרטון קצר',
  },
  uses: {
    eyebrow: 'למי זה מתאים',
    title: 'לכל מי שמוכר או מגייס בפייסבוק.',
    items: [
      ['מתווכי נדל״ן', 'כל נכס בכל קבוצת שכונה, וכל ״מעוניין״ מקבל את המספר שלכם.', '״3 חדרים ברמת גן, דברו איתי.״'],
      ['עסקים קטנים וחנויות', 'מבצעים ומוצרים חדשים בכל הקבוצות הרלוונטיות, כל יום, בלי להזיז אצבע.', '״מבצע קיץ, היום בלבד.״'],
      ['מגייסים ומעסיקים', 'מודעות דרושים בכל קבוצות הדרושים בארץ, וכל מועמד מקבל את השלב הבא.', '״דרושים נציגי מכירות, אזור המרכז.״'],
      ['סוחרי רכב', 'המלאי שלכם במרקטפלייס ובכל קבוצות הקנייה-מכירה, עם מענה לכל קונה.', '״קיה פיקנטו 2021, קילומטראז׳ נמוך.״'],
      ['נותני שירות', 'אינסטלטורים, מובילים, ניקיון, מורים פרטיים: השם הראשון בכל קבוצה מקומית.', '״הובלות בשרון, הצעת מחיר חינם.״'],
      ['אירועים וקורסים', 'ממלאים מקומות עם פרסום בכל קהילה רלוונטית ומענה לכל מי ששואל.', '״מקומות אחרונים לסדנה ביום ראשון.״'],
    ],
  },
  pricing: {
    eyebrow: 'מחיר',
    title: 'הכול כלול. מחיר חודשי אחד.',
    lede: 'השקעה קטנה לעומת מה שזה יכול להכניס. לקוח חדש אחד מכסה את זה כמה פעמים, וכל יום שמחכים, הלידים האלה הולכים למישהו אחר. ואנחנו מתחייבים למחיר הזול בעולם.',
    price: '₪290',
    per: 'לחודש · ביטול בכל עת',
        features: [
      'פרסום אוטומטי בכל הקבוצות הרלוונטיות, 7:00–23:00',
      'הצטרפות אוטומטית לקבוצות חדשות',
      'פרסום מהפרופיל ומהדפים העסקיים',
      'תיוג ומענה לכל מי שמגיב',
      'מענה אוטומטי במסנג׳ר',
      'ניהול מרקטפלייס',
      'גישה למאגר הקבוצות הגדול בישראל',
      'רץ בענן מאובטח, בתוך המגבלות של הפרופיל',
      'דשבורד אחד לכל הפוסטים',
      'שירות לקוחות כל יום, 9:00–17:00',
    ],
    cta: 'מתחילים ניסיון חינם',
    guarantee: 'מנוי חודשי. ביטול בכל עת בהודעה לשירות הלקוחות.',
  },
  lead: {
    title: 'עוד לא בטוחים?',
    lede: 'השאירו פרטים ונחזור אליכם כדי להראות איך זה יעבוד לעסק שלכם.',
    name: 'שם',
    phone: 'טלפון',
    email: 'אימייל (לא חובה)',
    submit: 'חזרו אליי בוואטסאפ',
    busy: 'שולחים…',
    sent: 'פתחנו לכם וואטסאפ עם הפרטים. לוחצים ״שליחה״ ונחזור אליכם.',
    error: 'השליחה נכשלה. בדקו את מספר הטלפון ונסו שוב.',
  },
  faq: {
    eyebrow: 'שאלות נפוצות',
    title: 'מה שכולם שואלים קודם.',
    items: [
      ['זה בטוח לפרופיל שלי בפייסבוק?', 'FBZipper רץ בענן המאובטח שלנו עם הפרופיל שלכם, ועושה הכול כמו שבן אדם היה עושה: בקצב אנושי, עם הפסקות אקראיות בין פוסטים, הצטרפויות ותגובות. הוא תמיד נשאר בתוך המגבלות היומיות של הפרופיל, כדי שהפרופיל לא יוגבל.'],
      ['לאילו קבוצות הפוסטים שלי יגיעו?', 'יש לנו מאגר של כל קבוצות הפייסבוק בישראל, מפולחות לפי קטגוריה, תחום ואזור. אתם בוחרים את מה שמתאים לעסק שלכם, ו-FBZipper מצטרף בשבילכם אוטומטית לקבוצות רלוונטיות חדשות.'],
      ['איך הלידים מגיעים אליי?', 'כל מי שמגיב על הפוסטים ״אשמח לפרטים״, שואל על המחיר או כל דבר אחר, מקבל תיוג ותשובה עם הפרטים שלכם. גם כל הודעה במסנג׳ר מקבלת מענה אוטומטי. כך אנשים פונים אליכם ישירות בטלפון או בוואטסאפ.'],
      ['אני צריך לעשות משהו?', 'לחבר את הפרופיל (זה לוקח דקות) ולהעלות את הפוסטים, התמונות והפרטים לדשבורד. FBZipper מטפל בכל השאר, כל יום.'],
      ['אפשר לפרסם גם מהדפים העסקיים שלי?', 'כן. חוץ מהפרופיל האישי, אפשר לפרסם גם מהדפים העסקיים שלכם, וכך יוצאים יותר פוסטים כל יום.'],
      ['ומה עם מרקטפלייס?', 'אנחנו מנהלים את כל המודעות שלכם במרקטפלייס ממקום אחד: סנכרון, עריכה, מענה לקונים ויצירת מודעות חדשות.'],
      ['כמה זה עולה ואיך מבטלים?', '₪290 לחודש, הכול כלול. זה מנוי חודשי. כדי לבטל, שולחים הודעה לשירות הלקוחות והמנוי לא יתחדש.'],
      ['מתי שירות הלקוחות זמין?', 'כל יום בין 9:00 ל-17:00, בטלפון, בוואטסאפ או במייל.'],
    ],
  },
  contact: {
    eyebrow: 'צור קשר',
    title: 'שאלות? כתבו לנו.',
    lede: 'אפשר לשאול כל דבר על FBZipper, קמפיינים, קבוצות או תשלום. שירות הלקוחות זמין כל יום, 9:00–17:00.',
    name: 'שם',
    email: 'אימייל',
    phone: 'טלפון (לא חובה)',
    message: 'הודעה',
    submit: 'שליחה בוואטסאפ',
    busy: 'שולחים…',
    sent: 'פתחנו לכם וואטסאפ עם ההודעה. לוחצים ״שליחה״ ונחזור אליכם.',
    error: 'השליחה נכשלה. נסו שוב, או כתבו ל-support@fbzipper.co.il.',
  },
  whatsapp: {
    label: 'דברו איתנו בוואטסאפ',
    message: 'היי, יש לי שאלה על FBZipper.',
    title: 'תמיכה',
    sub: 'יש שאלה? שאלו אותי בלייב',
    online: 'מחובר/ת עכשיו',
    offline: 'נחזור אליכם',
  },
  final: { title: ['מחר ב-7 בבוקר הפוסטים שלכם כבר יכולים ', 'להביא לידים', '.'], sub: 'השקעה קטנה, עם הרבה פוטנציאל. למה לחכות עוד יום?', together: 'תנו לנו להוכיח לכם. אנחנו כאן לטווח הארוך, ומצפים לקשר ארוך איתכם. בעזרת השם, נעבוד יחד עוד שנים רבות. 🤝' },
  footer: {
    legal: '© 2026 FBZipper. לא קשור ל-Meta Platforms, Inc. ואינו מאושר על ידה. Facebook הוא סימן מסחרי של Meta Platforms, Inc.',
    links: ['פרטיות', 'תנאי שימוש', 'צור קשר'],
  },
  // Register / login dialogs. They create the account and sign in through the app's own API
  // (the same calls as /auth/register and /auth/login).
  auth: {
    close: 'סגירה',
    register: {
      title: '7 ימי ניסיון בחינם',
      sub: 'בלי תשלום ובלי כרטיס אשראי. ממלאים פרטים ונכנסים ישר למערכת.',
      name: 'שם מלא',
      phone: 'טלפון נייד',
      email: 'אימייל (לא חובה)',
      password: 'סיסמה',
      passwordHint: 'לפחות 4 תווים. איתה תתחברו למערכת.',
      submit: 'מתחילים ניסיון חינם',
      busy: 'יוצרים לכם חשבון…',
      done: 'החשבון מוכן! מעבירים אתכם למערכת…',
      terms: ['בהרשמה אני מסכים/ה ל', 'תנאי השימוש', ' ול', 'מדיניות הפרטיות', '.'],
      missingName: 'יש להזין שם מלא',
      badPhone: 'יש להזין מספר טלפון נייד ישראלי תקין (לדוגמה 050-1234567)',
      badPassword: 'יש לבחור סיסמה (לפחות 4 תווים)',
      error: 'ההרשמה נכשלה, נסו שוב',
      haveAccount: 'כבר יש לכם חשבון? התחברו',
    },
    login: {
      title: 'התחברות',
      sub: 'התחברו עם האימייל (או הטלפון) והסיסמה שבחרתם בהרשמה.',
      email: 'אימייל',
      password: 'סיסמה',
      submit: 'התחברות',
      busy: 'מתחברים…',
      done: 'מחוברים! מעבירים אתכם למערכת…',
      wrong: 'האימייל או הסיסמה שגויים',
      forgot: 'שכחתם סיסמה?',
      noAccount: 'אין לכם חשבון? מתחילים ניסיון חינם',
    },
  },
};
